export enum CheckDepositColumns {
	id = "Id",
	org = "Org",
	vendor = "Vendor",
	customer = "Customer",
	accountId = "Account",
	checkNumber = "Check number",
	status = "Status",
	depositDate = "Deposit Date",
	amount = "Amount",
	expectedCompletionDate = "Expected Completion Date",
	actions = "Actions",
	reason = "Reason",
}

export type AllowedCheckDepositColumns =
	| CheckDepositColumns.id
	| CheckDepositColumns.org
	| CheckDepositColumns.vendor
	| CheckDepositColumns.customer
	| CheckDepositColumns.accountId
	| CheckDepositColumns.checkNumber
	| CheckDepositColumns.status
	| CheckDepositColumns.depositDate
	| CheckDepositColumns.amount
	| CheckDepositColumns.expectedCompletionDate
	| CheckDepositColumns.actions
	| CheckDepositColumns.reason
